import { useMemo } from 'react';

import useUserManagement from '@polyai/common/hooks/useUserManagement';

import api from 'api';
import { useAppSelector } from 'hooks/reduxHooks';

interface UseCurrentUserTagsOptions {
  accountId?: string;
  isEnabled?: boolean;
}

export const useCurrentUserTags = (
  options?: UseCurrentUserTagsOptions,
): string[] | undefined => {
  const { accountId, isEnabled = !!accountId } = options || {};
  const userEmail = useAppSelector(state => state.auth.user?.email);

  const { usersForAccount } = useUserManagement({
    api: {
      getUsers: api.getUsers,
      patchUsers: body => api.patchUsers({ accountId: accountId || '', body }),
      deleteUsers: userEmails =>
        api.deleteUsers({ accountId: accountId || '', userEmails }),
    },
    isEnabled,
    currentUserEmail: userEmail,
  });

  return useMemo(() => {
    if (!userEmail || !usersForAccount) {
      return undefined;
    }

    const sanitisedUserEmail = userEmail.toLowerCase();
    const currUserDetails = usersForAccount.find(
      user => user.user_email === sanitisedUserEmail,
    );

    return currUserDetails?.tags;
  }, [usersForAccount, userEmail]);
};
